import { render, staticRenderFns } from "./Tables.vue?vue&type=template&id=775f6021&scoped=true"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"
import style0 from "./Tables.vue?vue&type=style&index=0&id=775f6021&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775f6021",
  null
  
)

export default component.exports